import { CommunityMembershipRequestDeclinedNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { FormattedText, Typography } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { prepareHubItemTitle } from "./AnnouncementActivity";

export type CommunityMembershipRequestDeclinedActivityProps = {
	data: CommunityMembershipRequestDeclinedNotificationDataViewModel;
};

export const CommunityMembershipRequestDeclinedActivity = (props: CommunityMembershipRequestDeclinedActivityProps): ReactElement => {
	const { data } = props;

	return (
		<span {...setTrackingId("title")}>
			<FormattedText
				text={localize("_YourRequestToJoinCommunityNameWasDeclined")}
				thingsToReplace={[
					{
						what: "{{CommunityName}}",
						filler: (
							<Typography
								trackingId="community-name"
								weight="bold"
							>
								{prepareHubItemTitle(data.communityName)}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};
CommunityMembershipRequestDeclinedActivity.displayName = "CommunityMembershipRequestDeclinedActivity";
